import { defineStore } from "pinia";
import { computed, ref } from "vue";
import api from "@/utils/axios";
import { useAuthStore } from "@/stores/auth";

export const useChatUnreadStore = defineStore("chatUnread", () => {
  const total = ref(0);
  const personal = ref(0);
  const board = ref(0);
  const loading = ref(false);
  let timer: ReturnType<typeof setInterval> | null = null;
  let refreshSeq = 0;

  const auth = useAuthStore();

  const hasUnread = computed(() => total.value > 0);
  const badgeLabel = computed(() => (total.value > 99 ? "99+" : String(total.value)));

  const refresh = async () => {
    if (!auth.isAuthenticated) {
      total.value = 0;
      personal.value = 0;
      board.value = 0;
      return;
    }
    const seq = ++refreshSeq;
    loading.value = true;
    try {
      const res = await api.get("/chat/unread");
      if (seq !== refreshSeq) return;
      const data = res.data?.data || {};
      personal.value = Number(data.personal || 0);
      board.value = Number(data.board || 0);
      total.value = Number(data.total || personal.value + board.value);
    } catch {
      /* silencioso */
    } finally {
      if (seq === refreshSeq) loading.value = false;
    }
  };

  /** Tras abrir unha sala (markRead no backend): refresco inmediato + outro curto por se hai race. */
  const onRoomViewed = () => {
    void refresh();
    window.setTimeout(() => void refresh(), 400);
  };

  const startPolling = () => {
    stopPolling();
    void refresh();
    timer = setInterval(() => void refresh(), 20000);
  };

  const stopPolling = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  return {
    total,
    personal,
    board,
    loading,
    hasUnread,
    badgeLabel,
    refresh,
    onRoomViewed,
    startPolling,
    stopPolling,
  };
});
